import { render } from "./AuthorView.vue?vue&type=template&id=148663dd&ts=true"
import script from "./AuthorView.vue?vue&type=script&lang=ts"
export * from "./AuthorView.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__